export default {
	CheckStatusSupplier: 'Kiểm tra tình trạng hoạt động NCC',
	Check: 'Kiểm tra',
	PlaceholderSearch: 'Nhập Tên, Mã số thuế để tìm kiếm',
	NameSupplier: 'Tên đơn vị',
	NameSupplierNew: 'Tên nhà cung cấp/khách hàng',
	TaxCode: 'Mã số thuế',
	TaxCodeStructure: 'Mã số thuế NCC (cấu trúc 10 hoặc 14 ký tự)',
	PersonalIdCode: 'CCCD chủ hộ',
	PersonalIdCodeStructure: 'CCCD chủ HKD đối với NCC là HKD (cấu trúc 12 ký tự)',
	TotalInvoice: 'Số lượng HĐ',
	ActiveStatus: 'Tình trạng',
	DateCheck: 'Ngày kiểm tra',
	SupplierCode: 'Mã NCC',
	SupplierCodeNew: 'Mã đơn vị',
	Edit: 'Sửa',
	Import: 'Nhập khẩu',
	ImportExcel: 'Nhập từ Excel',
	CheckAgain: 'Kiểm tra lại',
	Export: 'Xuất khẩu',
	InfoSupplier: 'Thông tin nhà cung cấp/khách hàng',
	Address: 'Địa chỉ',
	InfoSupplierAccept: 'Thông tin nhà cung cấp/khách hàng được chấp nhận',
	SuccessEditSupplier: 'Đã sửa thành công',
	InfoAccept: 'Tên/địa chỉ được chấp nhận',
	StartDate: 'Ngày bắt đầu',
	EndDate: 'Ngày kết thúc',
	PersonAccept: 'Người chấp nhận',
	WarningDataChange:
		'<span class="title-toast-message">Dữ liệu chưa đươc lưu.</span><br>Bạn có chắc chắn muốn hủy bỏ?',
	ImportSupplierCode: 'Nhập khẩu thông tin NCC',
	ImportFile: '1. Tải tệp nhập khẩu',
	StepChooseFile: 'Chọn tệp',
	MergeInfo: '2. Ghép trường thông tin',
	StepMergeData: 'Ghép dữ liệu',
	CheckData: '3. Kiểm tra dữ liệu',
	StepPreviewData: 'Xem trước dữ liệu',
	Result: '4. Nhập khẩu',
	StepResult: 'Kết quả',
	Continue: 'Tiếp tục',
	Cancel: 'Hủy',
	Back: 'Quay lại',
	Import: 'Nhập khẩu',
	Next: 'Tiếp theo',
	CheckDuplicate: 'Kiểm tra trùng',
	ColDataApp: 'Cột dữ liệu trên phần mềm',
	ColDataFile: 'Cột dữ liệu trên tệp dữ liệu',
	Instructions: 'Hướng dẫn nhập liệu',
	ActionExistInfo: 'Khi gặp thông tin đã có trên hệ thống thì:',
	Skip: 'Bỏ qua',
	Update: 'Cập nhật',
	SelectFile: 'Chọn tệp',
	ChooseFileData: 'Chọn tệp dữ liệu',
	PleaseUploadFileFirst: 'Vui lòng tải lên tệp dữ liệu trước khi nhấn tiếp tục.',
	ReplaySelectFile: 'Chọn tệp khác',
	UploadSuccess: 'Tải tệp thành công hoặc ',
	DragDropFile: 'Kéo thả tệp nguồn vào đây',
	Or: 'Hoặc',
	OrDragDropFile: 'hoặc kéo thả tệp nguồn vào đây',
	Line: '___________',
	FormatFile: 'Chương trình chỉ hỗ trợ các tệp có định dạng *.xls, *.xlsx, *.csv, *.ods',
	OrChooseFrom: 'hoặc chọn từ',
	Computer: 'Máy tính',
	FileFormat: 'Định dạng XLSX, XLS, ODS, CSV',
	Note: 'Lưu ý:  ',
	ResultNote: 'Để có kết quả nhập khẩu chính xác nhất hãy sử dụng tệp mẫu.  ',
	UploadFilePatern: 'Tải tệp mẫu cơ bản',
	SampleFileDesc: 'Bao gồm các trường bắt buộc và một số thông tin cơ bản khác',
	SheetImport: 'Sheet nhập khẩu',
	LineTitle: 'Dòng tiêu đề',
	LineText: 'Dòng',
	All: 'Tất cả',
	Invalid: 'Hợp lệ',
	NotInvalid: 'Không hợp lệ',
	DowloadFileResult: 'Tải về tệp chứa kết quả nhập khẩu',
	Import: 'Nhập khẩu',
	LoadImport: 'Đang thực hiện nhập khẩu mã NCC/Khách hàng',
	NoficationWaitImport:
		'Việc nhập khẩu mã nhà cung cấp/khách hàng có thể thực hiện mất một vài phút, chương trình sẽ hiện thị thông báo khi nhập khẩu hoàn tất',
	Close: 'Đóng',
	ImportSuccess: 'Nhập khẩu thành công',
	ImportResultTitle: 'Kết quả nhập khẩu',
	BackToList: 'Quay lại danh sách',
	ImportResultCompleted: 'Quá trình nhập khẩu tệp đã hoàn tất với kết quả:',
	AddSuccess: 'Thành công',
	AddFail: 'Thất bại',
	line: 'dòng',
	MessageMisMatched:
		'Cột <Mã NCC/Khách hàng, Tên NCC/Khách hàng, Mã số thuế>, trên phần mềm đang không khớp với cột dữ liệu nào trong tệp nhập khẩu. Bạn có muốn tiếp tục nhập khẩu không?',
	Skip: 'Bỏ qua',
	CompanyName: 'Công ty',
	BranchName: 'Chi nhánh',
	DepartmentName: 'Phòng ban',
	MemberName: 'Tên thành viên',
	ProvinceCode: 'Mã Tỉnh',
	ProvinceName: 'Tên Tỉnh',
	DistrictCode: 'Mã Quận/Huyện',
	DistrictName: 'Tên Quận/Huyện',
	InfoUnit: 'Thông tin đơn vị',
	InfoPayment: 'Thông tin thanh toán',
	InfoContact: 'Thông tin liên hệ',
	NumberAccount: 'Số tài khoản',
	NameAccount: 'Tên tài khoản',
	NameBank: 'Tên ngân hàng',
	Agency: 'Chi nhánh',
	NameContact: 'Tên người liên hệ',
	Email: 'Email',
	PhoneNumber: 'Số điện thoại',
	Position: 'Chức vụ',
	PaymentDueDate: 'Hạn thanh toán',
	SupplierNameNew: 'Nhà cung cấp/Khách hàng',
	PlaceholderSearchNew: 'Nhập Tên nhà cung cấp/khách hàng, Mã số thuế/CCCD chủ hộ để tìm kiếm',
	PaymentDueDate: 'Hạn thanh toán',
	NumberAccount: 'Số tài khoản',
	NameAccount: 'Tên tài khoản',
	BankName: 'Tên ngân hàng',
	Branch: 'Chi nhánh',
	Position: 'Chức vụ',
	AdviseUse: 'Tư vấn sử dụng',
	ChooseFileWithExtension: 'Vui lòng chọn tệp tin có định dạng (*.xls,*.xlsx,*.csv,*.ods)',
	CannotFindSheetOnDocument: 'Không tìm thấy sheet trên tài liệu',
	DateFromCreateInvoice: 'ngày kể từ ngày lập hóa đơn',
	WatchGuidHere: 'Xem hướng dẫn thiết lập',
	LogAlertDeleteInfo: {
		FirtsText: 'Xóa thông tin tên/địa chỉ chấp nhận của',
		SecondText: 'có hiệu lực từ ngày',
		EndText: 'đến ngày'
	},
	LogAlertEditInfo: {
		FirtsText: 'Sửa thông tin tên/địa chỉ chấp nhận',
		SecondText: 'từ',
		EndText: 'thành'
	},
	PersonContact: 'Người lên hệ',
	SupplierCodeDetail: 'Mã nhà cung cấp',
	SupplierName: 'Tên NCC',
	ColNotMatchData: {
		FirstText: 'Cột',
		SecondText:
			'trên phần mềm đang không khớp với cột dữ liệu nào trong tệp nhập khẩu. Bạn có muốn tiếp tục nhập khẩu không',
		WarningText: (mes1, mes2) => `Cột ${mes1} đang được ghép với cột ${mes2} trên tệp dữ liệu.`,
		WarningText1: 'Bạn có muốn tiếp tục nhập khẩu không?'
	},
	FilterSupplier: 'Lọc danh mục',
	ActiveStatusSupplier: 'Trạng thái NCC/Khách hàng',
	ActiveStatusSupplierNew: 'Tình trạng hoạt động',
	RiskStatusInvoice: 'Trạng thái rủi ro về hóa đơn',
	PlaceholderBranchSearch: 'Nhập Tên chi nhánh/phòng ban để tìm kiếm',
	InformationIsAccepted: 'Thông tin được chấp nhận bổ sung',
	TitleInfoAccept: 'Thông tin nhà cung cấp/khách hàng được chấp nhận',
	EditSupplier: 'Sửa nhà cung cấp/Khách hàng',
	AddressBusinessInvalid: 'Địa điểm bán hàng không trùng với văn phòng đại diện',
	MergeInfoCol: {
		SupplierCode: 'mã đơn vị',
		SupplierCode1: 'mã dv',
		TaxCode: 'mã số thuế',
		TaxCode1: 'mst',
		SellerName: 'tên nhà cung cấp/khách hàng',
		SellerName1: 'tên ncc/kh',
		SellerName2: 'tên ncc',
		SellerName3: 'tên nhà cung cấp',
		PaymentDueDate: 'hạn thanh toán',
		PaymentDueDate1: 'hạn tt',
		AccountNumber: 'số tài khoản',
		AccountNumber1: 'số tk',
		AccountName: 'tên tài khoản',
		AccountName1: 'tên tk',
		BankName: 'tên ngân hàng',
		BankName1: 'tên nh',
		Branch: 'chi nhánh',
		NameContact: 'người liên hệ',
		NameContact1: 'người lh',
		Email: 'email',
		PhoneNumber: 'số điện thoại',
		PhoneNumber1: 'số dt',
		Position: 'chức vụ',
		Address: 'địa chỉ',
		Address1: 'đc'
	},
	Tooltip: {
		SupplierName: 'Tên nhà cung cấp'
	},
	ActiveSeller: {
		Active1: 'NNT tạm nghỉ kinh doanh có thời hạn',
		Active2: 'NNT đang hoạt động (đã được cấp GCN ĐKT)',
		Active3: 'NNT không hoạt động tại địa chỉ đã đăng ký',
		Active4: 'DN đang hoạt động (được cấp thông báo MST)',
		Active5: 'NNT ngừng hoạt động nhưng chưa hoàn thành thủ tục đóng MST',
		Active6: 'NNT ngừng hoạt động và đã đóng MST',
		Active7: 'DN đang hoạt động (đã được cấp GCN ĐKT)',
		Active8: 'NNT đã chuyển Cơ quan thuế quản lý',
		Active9: 'NNT đang hoạt động (được cấp thông báo MST)',
		Active10: 'NNT chờ làm thủ tục phá sản',
		Active11: 'NNT đã được cấp MST',
		Active12: 'NNT chờ xác minh tình trạng hoạt động tại địa chỉ đã đăng ký',
		Active13: 'Mã số thuế chờ cập nhật thông tin số định danh cá nhân'
	},
	//Các TH của MISA ORG
	//00: NNT đang hoạt động (đã được cấp GCN ĐKT) => Đang hoạt động
	//01: NNT ngừng hoạt động và đã đóng MST => Ngừng hoạt động
	//02: NNT đã chuyển cơ quan thuế quản lý => Đang hoạt động
	//03: NNT ngừng hoạt động nhưng chưa hoàn thành thủ tục đóng MST => Ngừng hoạt động
	//04: NNT đang hoạt động(được cấp thông báo MST) => Đang hoạt động
	//05: NNT tạm nghỉ kinh doanh có thời hạn => Ngừng hoạt động
	//06: NNT không hoạt động tại địa chỉ đã đăng ký  => Ngừng hoạt động => Tương ứng trạng thái "06"
	//07: NNT chờ làm thủ tục phá sản => Đang hoạt động

	RiskStatus: {
		Risky: 'Có rủi ro cao về thuế và hóa đơn theo công văn của CQT',
		RiskDocument: document => `Có rủi ro cao về thuế và hóa đơn theo Công văn ${document}`,
		NoRisk: 'Không thuộc danh sách có rủi ro cao về thuế và hóa đơn',
		RiskyActiveStatus: 'Có rủi ro cao về thuế và hóa đơn',
		TooltipRiskyActiveStatus:
			'Có rủi ro cao về thuế và hóa đơn do tình trạng hoạt động là "NNT không hoạt động tại địa chỉ đã đăng ký" tại ngày hóa đơn',
		TitleHistoryActiveStatus: 'Lịch sử tình trạng hoạt động',
		ResultUpdateHistory: 'Kết quả cập nhật từ ngày '
	},
	CheckOneSupplierCompleted: 'Hoàn tất kiểm tra nhà cung cấp/khách hàng',
	CheckOneSupplierFailed: 'Kiểm tra nhà cung cấp/khách hàng thất bại',
	CheckAllSupplierCompleted: 'Hoàn tất kiểm tra nhà cung cấp/khách hàng',
	HistoryVatRate: 'Lịch sử thuế suất hàng hóa',
	HistoryVat: 'Lịch sử thuế suất'
};
